<template>
  <rest-page :fetch-endpoint="fetchEndpoint" v-loading="isLoading">
    <channels-section
      :channels="channels"
      :channels-state="model"
      :channels-in-progress="inProgressChannels"
      @toggle="notify"
      @requestChannel="requestChannel"
    />
    <email-verification-popup
      ref="verificationPopup"
      @verification-refusal="emailVerificationRefusal"
      @verification-status="setEmailVerificationStatus"
    />
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import ChannelsSection from '@/modules/settings/components/ChannelsSection'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, customConfirm } from '@/core/helpers'
import { cloneDeep } from 'lodash'
import { emailVerificationEnum } from '@/modules/settings/enum/EmailVerificationEnum'
import EmailVerificationPopup from '@/modules/settings/components/EmailVerificationPopup'

export default {
  name: 'EnableChannelsTab',

  components: {
    RestPage,
    ChannelsSection,
    EmailVerificationPopup
  },

  data() {
    return {
      isLoading: false,
      channels: {},
      serverState: {},
      model: {
        email: 0,
        sms: 0,
        facebook: 0,
        whatsapp: 0,
        webhook: 0,
        email_verification: emailVerificationEnum.NOT_VERIFIED
      },
      inProgressChannels: [],
      emailVerificationEnum
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``,
        params: {
          expand: 'channels,inbox,email_verification'
        },
        handler: this.updateLocalData
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: '',
        params: {
          expand: 'channels,inbox,email_verification'
        }
      })
    },

    channelRequestEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: 'channel-request'
      })
    }
  },

  methods: {
    notify(payload) {
      if (payload.value === 0) {
        this.showPopup(payload)
      } else {
        this.save(payload)
      }
    },

    showPopup(payload) {
      customConfirm(
        this.$t('ApplicationsChannels_DisableTitle'),
        this.$t('ApplicationsChannels_DisableMessage'),
        this.$t('ApplicationsChannels_Disable'),
        undefined,
        undefined,
        ' custom-confirm-ce'
      )
        .then(_ => this.save(payload))
        .catch(_ => {})
    },

    save(payload) {
      this.isLoading = true
      const newState = {
        ...this.serverState
      }

      if (payload) {
        newState[payload.channel] = payload.value
      }

      if (
        newState.email &&
        newState.email_verification === emailVerificationEnum.NOT_VERIFIED
      ) {
        this.$refs.verificationPopup.show()
        return
      }

      RestApi({
        ...this.saveEndpoint,
        data: newState
      })
        .then(({ data }) => {
          this.updateLocalData(data)
          this.$store.dispatch('refreshPlatformChannels')
          this.$store.dispatch('reloadProjectConfig')
          this.$message({
            message:
              payload.value === 1
                ? this.$t('Channels_ChangesSuccessfulEnabled')
                : this.$t('Channels_ChangesSuccessfulDisabled'),
            type: 'success'
          })
          this.isLoading = false
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.isLoading = false
        })
    },

    setEmailVerificationStatus(status) {
      this.serverState.email_verification = status
      this.save({ channel: 'email', value: 1 })
    },

    emailVerificationRefusal(save = true) {
      this.serverState.email = 0
      this.serverState.email_verification = emailVerificationEnum.NOT_VERIFIED
      if (save) {
        this.save()
      }
    },

    updateLocalData(data) {
      this.serverState = cloneDeep(data)
      this.model = {
        email: data.email,
        sms: data.sms,
        facebook: data.facebook,
        whatsapp: data.whatsapp,
        webhook: data.webhook,
        email_verification: data.email_verification
      }
      this.channels = data.channels
    },

    requestChannel(channel) {
      const payload = {
        user_id: this.$store.state.app.user.uid,
        project_id: this.$route.query.project_id,
        channel: channel
      }

      customConfirm(
        this.$t('Channels_RequestChannel_Title', {
          channel: this.$data.channels[channel].title
        }),
        this.$t('Channels_RequestChannel_Message'),
        this.$t('Channels_RequestChannel_Confirm'),
        undefined,
        undefined,
        ' custom-confirm-ce'
      )
        .then(result => {
          if (!this.inProgressChannels.includes(channel)) {
            this.inProgressChannels.push(channel)
          }

          RestApi({
            ...this.channelRequestEndpoint,
            data: payload
          })
            .then(({ data }) => {
              if (data.id) {
                this.channels[channel].requestStatus = data.status
              }

              if (this.inProgressChannels.includes(channel)) {
                this.inProgressChannels = this.inProgressChannels.filter(
                  item => item !== channel
                )
              }
            })
            .catch(error => {
              this.$message({
                message: error.message,
                type: 'error'
              })

              if (this.inProgressChannels.includes(channel)) {
                this.inProgressChannels = this.inProgressChannels.filter(
                  item => item !== channel
                )
              }
            })
        })
        .catch(_ => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/components/EnableChannelsTab.vue